import {DetailsList, PrimaryButton, SelectionMode} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddUser from "../Panel/User/AddUser";
import {Link, useOutletContext} from "react-router-dom";

function User(props) {
    const [auth] = useContext(AuthContext);
    const [users, setUsers] = useState([]);
    const [refresh, setRefresh] = useState(0);
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/user", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + auth.token
                }
            }).then(res => res.json())
                .then(data => { setUsers(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh]);
    const [addUser, setAddUser] = useState(false);
    const actions = useOutletContext();
    useEffect(() => {
        actions([
            {
                key: 'addUser',
                text: 'Dodaj Użytkownika',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddUser(true)
            }
        ]);
        return actions;
    }, []);

    const columns = [
        {
            key: 'email',
            name: 'Email',
            ariaLabel: 'Email',
            fieldName: 'email',
            minWidth: 160,
            isRowHeader: true,
            isResizable: true,
            onRender: (item) => (<Link to={`/user/${item.id}`}><PrimaryButton text={item.email} /></Link>)
        },
        {
            key: 'name',
            name: 'Imię',
            ariaLabel: 'Imię',
            fieldName: 'name',
            minWidth: 120,
            isResizable: true,
        },
        {
            key: 'surname',
            name: 'Nazwisko',
            ariaLabel: 'Nazwisko',
            fieldName: 'surname',
            minWidth: 180,
            isResizable: true,
        },
        {
            key: 'role',
            name: 'Role',
            ariaLabel: 'Role',
            fieldName: 'role',
            minWidth: 240,
            isResizable: true,
        },
        {
            key: 'venture_restricted',
            name: 'OxK',
            ariaLabel: 'Ograniczenie kontraktów',
            fieldName: 'venture_restricted',
            minWidth: 40,
        },
        {
            key: 'document_restricted',
            name: 'OxD',
            ariaLabel: 'Ograniczenie dokumentów',
            fieldName: 'document_restricted',
            minWidth: 40,
        }
    ];

    return (
        <AppContent title={'Konta Użytkowników'}>
            <DetailsList items={users} columns={columns} selectionMode={SelectionMode.none}/>
            <AddUser add={addUser} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setAddUser(false)} />
        </AppContent>
    );
}

export default User;